import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import CartItem from 'components/Cart/CartItem';
import CartItemActions from 'bento-ordering/cart/components/CartItemActions';

const CartGroupOrderItems = ({
  items = [],
  getEditCartItemPath,
  removeItemFromCart,
  handleEditClick,
  currentCartPath,
  hideItemActions = false
}) => (
  <Box component={List} disablePadding data-testid="cart-items-list">
    {items.map(item => {
      const editCartItemPath = getEditCartItemPath(item.id);
      const handleRemoveCartItem = () => removeItemFromCart(item.id);

      const ItemActions = hideItemActions ? null : (
        <CartItemActions
          currentCartPath={currentCartPath}
          editCartItemPath={editCartItemPath}
          onEditCartItem={handleEditClick}
          onRemoveCartItem={handleRemoveCartItem}
        />
      );

      return (
        <ListItem key={item.id} disableGutters>
          <CartItem item={item} itemActions={ItemActions} />
        </ListItem>
      );
    })}
  </Box>
);

CartGroupOrderItems.propTypes = {
  items: PropTypes.array,
  getEditCartItemPath: PropTypes.func,
  removeItemFromCart: PropTypes.func,
  handleEditClick: PropTypes.func,
  currentCartPath: PropTypes.string,
  hideItemActions: PropTypes.bool
};

export default CartGroupOrderItems;
